<template>
  <div>
    <NotFound404Error class="!h-[480px] md:!h-[720px] 2xl:!h-screen" />
  </div>
</template>

<script setup>
</script>